import React, { useCallback, useState } from 'react'
import styled from 'styled-components'
import { useDidUpdateEffect } from '~/hooks/useDidUpdateEffect'
import { MyIcon } from '~/components/ui/MyIcon'
import { useRouter } from 'next/router'

const StyledRankTabs = styled.div`
  .tabs {
    padding-right: 32px;
    border-right: 1px solid ${props => props.theme.light1};
    margin-right: 32px;
    .tabs-item {
      width: 112px;
      height: 48px;
      color: ${props => props.theme.dark5};
      margin-bottom: 44px;
      font-weight: 600;
      padding: 12px;
      font-size: 14px;
      line-height: 24px;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      .icon {
        font-size: 22px;
        margin-right: 8px;
      }
    }
    .active {
      background-color: #000;
      color: #fff;
    }
  }
`

export interface IndexTabsItemProps {
  key: string
  name: string
  icon: string
}

/** 首页排行榜切换 */
export const RankIndexTabs: React.FC<{
  data: IndexTabsItemProps[]
  onChange: (item: IndexTabsItemProps) => void
  className?: string
  style?: React.CSSProperties
  defaultValue: string
}> = ({ data, onChange, className, style, defaultValue }) => {
  const [currentIndex, setCurrentIndex] = useState(defaultValue)
  const onTabItem = useCallback(
    (item: IndexTabsItemProps) => {
      if (currentIndex === item.key) return
      setCurrentIndex(item.key)
      onChange(item)
    },
    [onChange, currentIndex]
  )
  useDidUpdateEffect(() => {
    setCurrentIndex(defaultValue)
  }, [defaultValue])
  if (data.length === 0) {
    return null
  }
  return (
    <StyledRankTabs className={className} style={style}>
      <div className="tabs">
        {data?.map(item => (
          <a
            className={
              currentIndex === item.key ? 'tabs-item active' : 'tabs-item'
            }
            onClick={() => onTabItem(item)}
            key={item.key}
          >
            <MyIcon icon={item.icon} className="icon" />
            {item.name}
          </a>
        ))}
      </div>
    </StyledRankTabs>
  )
}
